//region block: pre-declaration
//endregion
function component1(_this__u8e3s4) {
  return _this__u8e3s4.sequence;
}
function component2(_this__u8e3s4) {
  return _this__u8e3s4.speed;
}
function component3(_this__u8e3s4) {
  return _this__u8e3s4.child;
}
//region block: exports
export {
  component1 as component11cgra71sux02t,
  component2 as component21bl9a2wgotvv9,
  component3 as component31p8u65el5igun,
};
//endregion

//# sourceMappingURL=FrameRunnerPropsExtentions.mjs.map
